const removeEmptyMeetingParams = (params = {}) => {
  return Object.keys(params).reduce((definedParams, key) => {
    const value = params[key];

    if (value !== null && value !== undefined && value !== '') {
      definedParams[key] = value;
    }

    return definedParams;
  }, {});
};

const getAssignedUserId = (item = {}) => {
  const { Users = [] } = item;
  const assignedUser = Users.length > 0 ? Users[0] : null;

  return assignedUser ? assignedUser.pk_User : null;
};

export const createMeetingContext = ({
  department = {},
  season = {},
  item = {},
  interviewDateId = null,
  isAllDay = false,
} = {}) => {
  const context = {
    pk_Department: department.pk_Department,
    pk_Season: season.pk_Season,
    pk_InterviewDate: item.pk_InterviewDate || interviewDateId,
    pk_ScheduleBlock: item.pk_ScheduleBlock,
    pk_FlexEvent: item.pk_FlexEvent,
    pk_Timeslot: item.pk_Timeslot,
    pk_ScheduleAssignment: item.pk_ScheduleAssignment,
    pk_User: getAssignedUserId(item),
    isAllDay: Boolean(isAllDay),
  };

  return Object.freeze(context);
};

export const getMeetingContextKey = (context = {}) => {
  const values = [
    context.pk_Department,
    context.pk_Season,
    context.pk_InterviewDate,
    context.pk_ScheduleBlock,
    context.pk_FlexEvent,
    context.pk_Timeslot,
    context.pk_ScheduleAssignment,
    context.isAllDay ? 1 : 0,
  ];

  return values.map((value) => (value === null || value === undefined || value === '' ? '-' : value)).join(':');
};

export const getMeetingOperationKey = (context = {}, actorId = null) => {
  const normalizedActorId = actorId === null || actorId === undefined || actorId === '' ? '-' : actorId;

  return `${getMeetingContextKey(context)}:${normalizedActorId}`;
};

export const buildCandidateMeetingParams = (context = {}, candidateUUID = '') => {
  return removeEmptyMeetingParams({
    pk_Department: context.pk_Department,
    pk_Season: context.pk_Season,
    UUID: candidateUUID,
    pk_User: context.pk_User,
    pk_ScheduleBlock: context.pk_ScheduleBlock,
    pk_FlexEvent: context.pk_FlexEvent,
    pk_InterviewDate: context.pk_InterviewDate,
    pk_Timeslot: context.pk_Timeslot,
    pk_ScheduleAssignment: context.pk_ScheduleAssignment,
    isAllDay: context.isAllDay ? 1 : 0,
  });
};

export const buildEvaluatorMeetingParams = (context = {}, evaluatorId = null) => {
  return removeEmptyMeetingParams({
    pk_Department: context.pk_Department,
    pk_Season: context.pk_Season,
    pk_ScheduleBlock: context.pk_ScheduleBlock,
    pk_FlexEvent: context.pk_FlexEvent,
    pk_InterviewDate: context.pk_InterviewDate,
    pk_Timeslot: context.pk_Timeslot,
    pk_ScheduleAssignment: context.pk_ScheduleAssignment,
    pk_User: evaluatorId,
    isAllDay: context.isAllDay ? 1 : 0,
  });
};

export const buildMeetingRefreshUrl = (baseUrl = '', params = {}) => {
  const searchParams = new URLSearchParams(removeEmptyMeetingParams(params));
  const queryString = searchParams.toString();

  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
};
